import { render } from "./categoryButtons.vue?vue&type=template&id=17122973"
import script from "./categoryButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./categoryButtons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/whatsapp/pages/categories/list/components/categoryButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17122973"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17122973', __exports__)) {
    console.log('reload')
    api.reload('17122973', __exports__)
  }
  
  module.hot.accept("./categoryButtons.vue?vue&type=template&id=17122973", () => {
    console.log('re-render')
    api.rerender('17122973', render)
  })

}


export default __exports__